<template>
  <div class="team-report-front-page">
    <div class="team-report-front-page__top-info">
      <p><i18n-t keypath="pdfReport.frontpage_teamname" :locale="lang" tag="strong"></i18n-t>: {{teamName}}</p>
      <p><i18n-t keypath="pdfReport.frontpage_date" :locale="lang" tag="strong"></i18n-t>: {{today}}</p>
      <p><i18n-t keypath="pdfReport.frontpage_normgroup" :locale="lang" tag="strong"></i18n-t>: {{normGroup}}</p>
    </div>
    <i18n-t keypath="pdfReport.frontpage_teamreport" :locale="lang" tag="h1"></i18n-t>
    <i18n-t :keypath="`privatePage.expert_report_type_${titleKey}`" :locale="lang" tag="h2"></i18n-t>
    <div class="team-report-front-page__contents">
      <div>
        <div class="team-report-front-page__circle">
          <div class="team-report-front-page__checkmark"></div>
        </div>
        <i18n-t keypath="pdfReport.frontpage_content_intro" :locale="lang" tag="p"></i18n-t>
      </div>
      <div>
        <div class="team-report-front-page__circle">
          <div class="team-report-front-page__checkmark"></div>
        </div>
        <i18n-t keypath="pdfReport.frontpage_content_styles" :locale="lang" tag="p"></i18n-t>
      </div>
      <div>
        <div class="team-report-front-page__circle">
          <div class="team-report-front-page__checkmark"></div>
        </div>
        <i18n-t keypath="pdfReport.frontpage_content_results_team" :locale="lang" tag="p"></i18n-t>
      </div>
      <div>
        <div class="team-report-front-page__circle">
          <div class="team-report-front-page__checkmark"></div>
        </div>
        <i18n-t keypath="pdfReport.frontpage_content_results_individual" :locale="lang" tag="p"></i18n-t>
      </div>
    </div>
    <div class="team-report-front-page__bottom">
      <img src="../../assets/images/psytest_logo.png" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    lang: '',
    titleKey: '',
    normGroup: '',
    teamName: ''
  },
  computed: {
    today() {
      return new Date().toLocaleDateString(this.lang || 'sv-SE')
    }
  }
}
</script>

<style scoped lang="scss">
* {
  letter-spacing: initial!important;
}
h1 {
  font-size: 60px!important;
  margin: 180px 0 10px 0!important;
  color: #3e3e3f;
  width: 420px;
}
h2 {
  font-size: 22px!important;
  margin: 0 0 20px 0!important;
  padding: 0!important;
  color: #3e3e3f;
}
p,
p strong {
  font-size: 11px!important;
  margin: 0!important;
  padding: 0!important;
  max-width: 460px;
}
.team-report-front-page {
  padding: 0 60px;

  &__top-info {
    margin-top: 30px;
    padding-top: 30px;

    &::before {
      position: absolute;
      content: '';
      z-index: -1;
      top: 0;
      left: 30px;
      width: 0;
      height: 0;
      border-bottom: 220px solid transparent;
      border-left: 535px solid #d5effb;
    }
  }
  &__contents {
    margin-top: 40px;

    & > div {
      display: flex;
      align-items: center;
      margin-bottom: 2px;
    }
  }
  &__circle {
    position: relative;
    border-radius: 50%;
    border: 2px solid #0dbff2;
    width: 16px;
    height: 16px;
    margin-right: 5px;
  }
  &__checkmark {
    position: absolute;
    transform: rotate(45deg) translate(-50%, -50%);
    left: 25%;
    top: 45%;
    height: calc(8px);
    width: calc(5px);
    border-bottom: 2px solid #0dbff2;
    border-right: 2px solid #0dbff2;
  }
  &__bottom {
    position: relative;
    margin-top: 250px;
    padding-bottom: 30px;

    img {
      max-width: 120px;
      max-height: 120px;
      margin-left: -30px;
    }

    &::before {
      position: absolute;
      content: '';
      z-index: -1;
      bottom: 0;
      left: 85px;
      width: 0;
      height: 0;
      border-top: 180px solid transparent;
      border-right: 420px solid #0dbff2;
    }
  }
}
</style>
